import { render, staticRenderFns } from "./agency_product-record.vue?vue&type=template&id=16b19a38&scoped=true"
import script from "./agency_product-record.vue?vue&type=script&lang=ts"
export * from "./agency_product-record.vue?vue&type=script&lang=ts"
import style0 from "./agency_product-record.vue?vue&type=style&index=0&id=16b19a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b19a38",
  null
  
)

export default component.exports